import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaSun,
  FaMoon,
  FaUserPlus,
  FaSignInAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import { ThemeContext } from "../../context/ThemeContext";
import { AuthContext } from "../../context/AuthContext";
import "./Header.css";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleLogout = () => {
    logout();
    navigate("/");
    setIsNavOpen(false);
  };


  const handleSectionNavigation = (sectionId) => {
    setIsNavOpen(false);

    // If already on homepage, just scroll to the section
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to homepage and then scroll to section
      navigate("/", { state: { scrollToSection: sectionId } });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <h1>
                Pathshala <span>Sanchalak</span>
              </h1>
            </Link>
          </div>

          <div className="menu-icon" onClick={toggleNav}>
            {isNavOpen ? <FaTimes /> : <FaBars />}
          </div>
          <nav className={`nav-menu ${isNavOpen ? "active" : ""}`}>
            <ul>
              <li>
                <Link to="/#home" onClick={() => {
                  setIsNavOpen(false);
                  handleSectionNavigation("home");
                }}>
                  Home
                </Link>
              </li>
              <li>
                <a
                  href="/#about"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionNavigation("about");
                  }}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/#services"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionNavigation("services");
                  }}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="/#pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionNavigation("pricing");
                  }}
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSectionNavigation("contact");
                  }}
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="/user-guide"
                >
                  User Guide
                </a>
              </li>
              <li className="auth-links">
                {isAuthenticated ? (
                  <>
                    {/* {isAuthenticated && isNotDashboard && (
                      <Link
                        to="/dashboard"
                        onClick={() => setIsNavOpen(false)}
                        className="dashboard-button"
                      >
                        <FaTachometerAlt /> Dashboard
                      </Link>
                    )}
                    <Link
                      to="/dashboard"
                      onClick={() => setIsNavOpen(false)}
                      className="user-button"
                      title={user?.name || user?.email || "User"}
                    >
                      <FaUser />{" "}
                      <span className="username-text">
                        {user?.name || user?.email || "User"}
                      </span>
                    </Link> */}
                    <a href="/dashboard" >
                      Dashboard
                    </a>

                    {/* <button onClick={handleLogout} className="logout-button">
                      <FaSignOutAlt /> Logout
                    </button> */}
                  </>
                ) : (
                  <>
                    <Link
                      to="/login"
                      onClick={() => setIsNavOpen(false)}
                      className="login-button"
                    >
                      <FaSignInAlt /> Login
                    </Link>
                    <Link
                      to="/register"
                      onClick={() => setIsNavOpen(false)}
                      className="register-button"
                    >
                      <FaUserPlus /> Register
                    </Link>
                  </>
                )}
              </li>

              <li className="auth-links">
                {isAuthenticated && 
                <button onClick={handleLogout} className="logout-button">
                      <FaSignOutAlt /> Logout
                </button> }
              </li>

            </ul>
          </nav>
          <div className="dark-mode-toggle" onClick={toggleDarkMode}>
            {darkMode ? (
              <FaSun title="Switch to light mode" />
            ) : (
              <FaMoon title="Switch to dark mode" />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
